import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useSWRConfig } from 'swr';

export function useMutateOnRouting(targetKey?: string) {
    const router = useRouter();
    const { mutate } = useSWRConfig();
    useEffect(() => {
        const onRouteChangeStart = () => {
            mutate((key) => (targetKey ? key === targetKey : true));
        };
        router.events.on('routeChangeStart', onRouteChangeStart);
        return () => {
            router.events.off('routeChangeStart', onRouteChangeStart);
        };
    }, [targetKey, mutate, router.events]);
}
